import { ComponentProps } from 'react';
import { PickersDay as MuiPickersDay } from '@mui/x-date-pickers';
import { formatDate } from 'app/shared/utils/date';

export const PickersDay = (props: ComponentProps<typeof MuiPickersDay>) => {
  const { day } = props;
  return <MuiPickersDay aria-label={formatDate(day)} {...props} />;
};
